<app-navbar [title]="pageTitle">
	<button class="btn btn-warning me-4" *ngIf="!lockEdit" (click)="showDocumentTypes = !showDocumentTypes">
		<i class="fas fa-file-medical"></i> Dodaj typ dokumentu
	</button>
	<button class="btn btn-warning me-4" *ngIf="!lockEdit" (click)="sendersOpen()">
		<i class="far fa-address-card"></i> Nadawcy
	</button>
	<button class="btn btn-success me-4" *ngIf="!lockEdit" (click)="submit()">
		<i class="fas fa-check"></i> Zapisz
	</button>
	<a routerLink="/task/{{ task?.id }}" class="btn btn-primary me-4" *ngIf="editable" (click)="editToggle()">
		<i class="fas fa-tasks"></i> Przejedź do zadania
	</a>
	<button class="btn btn-primary me-4" *ngIf="lockEdit" (click)="editToggle()">
		<i class="fas fa-pencil-alt"></i> Edycja
	</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-mail-bulk"></i> Lista </a>
</app-navbar>

<app-post-document-types
	*ngIf="showDocumentTypes"
	[(documentTypes)]="documentTypes"
	(added)="showDocumentTypes = false"
></app-post-document-types>

<div class="modal" id="sendersModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-scrollable modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Modal title</h5>
				<button type="button" class="btn-close" (click)="sendersClose()"></button>
			</div>
			<div class="modal-body">
				<app-post-senders [(senders)]="senders" (changed)="sendersClose()"></app-post-senders>
			</div>
		</div>
	</div>
</div>

<div class="container">
	<form class="my-4" (submit)="submit()">
		<fieldset [disabled]="lockEdit">
			<div class="mb-3">
				<ng-select
					id="sender"
					name="sender"
					[(ngModel)]="post.sender"
					[items]="senders"
					placeholder="Nadawca"
					bindLabel="name"
					bindValue="id"
					[searchFn]="sendersSearch"
					[ngClass]="{ error: this.errors.sender }"
				>
					<ng-template ng-option-tmp let-item="item">
						{{ item.name }} <br />
						<small>{{ item.address }}</small>
					</ng-template>
				</ng-select>
			</div>
			<div class="form-floating mb-3">
				<select
					class="form-control"
					name="documentType"
					id="documentType"
					[(ngModel)]="post.documentType"
					[ngClass]="{ error: this.errors.documentType }"
				>
					<option value="{{ pos.id }}" *ngFor="let pos of documentTypes">{{ pos.name }}</option>
				</select>
				<label for="documentType">Typ dokumentu</label>
			</div>
			<div class="form-floating mb-3">
				<input
					type="date"
					class="form-control"
					id="received"
					name="received"
					[(ngModel)]="post.received"
					[ngClass]="{ error: this.errors.received }"
					placeholder="Data wpływu"
					required
				/>
				<label for="received">Data wpływu</label>
			</div>
			<div class="form-floating mb-3">
				<input
					type="date"
					class="form-control"
					id="due"
					name="due"
					[(ngModel)]="post.due"
					[ngClass]="{ error: this.errors.due }"
					placeholder="Termin realizacji"
					required
				/>
				<label for="due">Termin realizacji</label>
			</div>
			<div class="form-floating mb-3">
				<select
					class="form-control"
					name="recipient"
					id="recipient"
					[(ngModel)]="post.recipient"
					[ngClass]="{ error: this.errors.recipient }"
				>
					<option value="{{ pos.id }}" *ngFor="let pos of companies">{{ pos.name }}</option>
				</select>
				<label for="recipient">Odbiorca</label>
			</div>
			<div class="form-floating mb-3">
				<textarea
					class="form-control"
					id="description"
					name="description"
					[(ngModel)]="post.description"
					required
				></textarea>
				<label for="description">Opis</label>
			</div>

			<div class="form-floating mb-3">
				<select
					class="form-control"
					name="givenTo"
					id="givenTo"
					[(ngModel)]="post.givenTo"
					[ngClass]="{ error: this.errors.givenTo }"
				>
					<option value="{{ pos.id }}" *ngFor="let pos of users">{{ pos.name }}</option>
				</select>
				<label for="givenTo">Przekazano do</label>
			</div>

			<div class="form-floating mb-3">
				<select class="form-control" name="category" id="category" [(ngModel)]="post.category">
					@for (category of categories; track category.id) {
						<option value="{{ category.id }}">{{ category.name }}</option>
					}
				</select>
				<label for="category">Rodzaj przesyłki</label>
			</div>

			<div class="form-floating mb-3">
				<select class="form-control" name="courier" id="courier" [(ngModel)]="post.courier">
					@for (courier of couriers; track courier.id) {
						<option value="{{ courier.id }}">{{ courier.name }}</option>
					}
				</select>
				<label for="courier">Kurier</label>
			</div>

			<div class="form-floating mb-3">
				<select
					class="form-control"
					name="createdBy"
					id="createdBy"
					[(ngModel)]="post.createdBy"
					[ngClass]="{ error: this.errors.createdBy }"
				>
					@for (user of users; track user.id) {
						<option value="{{ user.id }}">{{ user.name }}</option>
					}
				</select>
				<label for="givenTo">Utworzone przez</label>
			</div>
		</fieldset>
	</form>
</div>
